import { render, staticRenderFns } from "./article.vue?vue&type=template&id=ce6ecc2c&scoped=true"
import script from "./article.vue?vue&type=script&lang=js"
export * from "./article.vue?vue&type=script&lang=js"
import style0 from "./article.vue?vue&type=style&index=0&id=ce6ecc2c&prod&lang=scss&scoped=true"
import style1 from "./article.vue?vue&type=style&index=1&id=ce6ecc2c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce6ecc2c",
  null
  
)

export default component.exports